// Controlled, compact form primitives used inside the Model editor's
// dynamic list/tree editors (Entradas / Campos de configuración).
// They intentionally don't reuse InputField/NumberField/SelectField: those
// are uncontrolled (defaultValue-based), which breaks when rows are
// added/removed/reordered — the DOM node gets reused for different data
// without picking up the new value.

export const slugify = (text) =>
  (text || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const baseInputClass =
  "mt-1 flex h-9 w-full items-center rounded-lg border border-gray-200 bg-white/0 px-2.5 text-sm outline-none transition-all duration-200 hover:border-gray-300 focus:border-brand-500 focus:shadow-[0_0_0_3px_rgba(67,24,255,0.12)] dark:border-white/10 dark:bg-navy-800/40 dark:text-white dark:hover:border-white/20 dark:focus:!border-brand-400";

// A shared width vocabulary so rows built from these primitives line up
// consistently and wrap (never overlap) when a container is too narrow —
// see FieldConfigEditor/EntradasEditor, which lay these out with flex-wrap
// instead of a fixed grid.
export const widths = {
  sm: "w-[86px]",
  md: "w-[120px]",
  lg: "w-[150px]",
  grow: "min-w-[160px] flex-1",
};

export const TextInput = ({ label, value, onChange, onBlur, placeholder, type = "text", className = "" }) => (
  <div className={className}>
    {label && (
      <label className="text-[11px] font-semibold text-gray-500 dark:text-gray-400">
        {label}
      </label>
    )}
    <input
      type={type}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={baseInputClass}
    />
  </div>
);

export const NumInput = ({ label, value, onChange, placeholder, className = "" }) => (
  <div className={className}>
    {label && (
      <label className="text-[11px] font-semibold text-gray-500 dark:text-gray-400">
        {label}
      </label>
    )}
    <input
      type="number"
      step="any"
      value={value ?? ""}
      onChange={onChange}
      placeholder={placeholder}
      className={baseInputClass}
    />
  </div>
);

export const TextArea = ({ label, value, onChange, placeholder, rows = 2, className = "" }) => (
  <div className={className}>
    {label && (
      <label className="text-[11px] font-semibold text-gray-500 dark:text-gray-400">
        {label}
      </label>
    )}
    <textarea
      value={value ?? ""}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className={`${baseInputClass} h-auto resize-none py-1.5`}
    />
  </div>
);

export const SelectInput = ({ label, value, onChange, options, placeholder = "Seleccione", className = "" }) => (
  <div className={className}>
    {label && (
      <label className="text-[11px] font-semibold text-gray-500 dark:text-gray-400">
        {label}
      </label>
    )}
    <select
      value={value ?? ""}
      onChange={onChange}
      className={`${baseInputClass} form-select appearance-none bg-no-repeat pr-8`}
    >
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);
